<template>
  <transition name="slide">
    <div class="hs-container c-purpose-travel" v-if="show" :class="{whiteBg: FieldSettings && Number(FieldSettings.ExtendFieldType) === 1}">
      <c-header class="c-header-new" leftIcon1="icons_24pt_back.png" :leftFn1="close" :title="ExtendFieldName" />
      <hs-search-bar-new
          v-if="FieldSettings && Number(FieldSettings.ExtendFieldType) === 1"
          className="style2"
          v-model="KeyWord"
          :placeholder="$t('Search_1')"
          :hasClear="!!KeyWord"
          @clear="KeyWord = ''"
      />
      <hs-scroll
        class="table-view"
        ref="tableView"
        :style="{height: FieldSettings && Number(FieldSettings.ExtendFieldType) === 1 ? 'calc(100% - 48px - 56px)' : 'calc(100% - 48px - 64px)'}"
        :data="datalist"
        :options="tableViewOptions"
        @pulling-down="_getDatalist"
        @pulling-up="_getDatalistMore"
      >
        <ul class="content">
          <template v-if="FieldSettings && Number(FieldSettings.ExtendFieldType) === 1">
            <hs-null
                v-if="datalist.length <= 0"
                style="padding-top: calc(40dvh - 88px)"
                styleType="empty"
                :title="$t('NoDataContent')"
            />
            <cost-centers-item
                v-for="(item, index) in datalist"
                :key="index"
                :active="value === item.Name"
                :item="item"
                @click.native="_selectedFun(index)"
            />
            <hs-all-load-text v-if="!tableViewOptions.pullUpLoad && datalist && datalist.length > 0" />
          </template>

          <hs-section v-else>
            <div class="tab-list">
              <div class="cell" v-for="(item, i) in datalist" :key="i"  @click="() =>_selectedFun(i)">
                <div class="info">
                  <img v-if="i === selIndex" class="icon-select" src="@/assets/image/base/check-box/icons_16pt_circle_s.png" alt="">
                  <img v-else class="icon-select" src="@/assets/image/base/check-box/icons_16pt_circle_s_1.png" alt="">
                  <span>{{item.Name}}</span>
                </div>
              </div>
              <div class="cell" v-if="FieldSettings && Number(FieldSettings.ExtendFieldType) === 2">
                <div class="info">
                  <img v-if="selIndex === 'other'" class="icon-select" src="@/assets/image/base/check-box/icons_16pt_circle_s.png" alt="">
                  <img v-else class="icon-select" src="@/assets/image/base/check-box/icons_16pt_circle_s_1.png" alt="">
                  <span>{{$t('Other')}}</span>
                </div>
                <hs-textarea
                    class="hs-textarea"
                    @click="() =>_selectedFun('other')"
                    v-model="suggestion"
                    height="100px"
                    width="calc(100% - 24px)"
                    :hasCount="true"
                    :maxlength="100"
                    :placeholder="$t('PleaseFill')"
                ></hs-textarea>
              </div>
            </div>
          </hs-section>
        </ul>
      </hs-scroll>
      <footer v-if="FieldSettings && Number(FieldSettings.ExtendFieldType) === 2">
        <hs-button width="100%" height="36px" font-size="14px" type="full-square" @click="_submit">{{ $t("Confirm") }}</hs-button>
      </footer>
    </div>
  </transition>
</template>

<script>
import {kpiUserGetOrderExtendFields, kpiUserGetEmployeeExtendFields} from 'api'
import HsNull from "@/base/hs-null/hs-null.vue";
import HsSearchBarNew from "@/base/hs-search-bar/hs-search-bar-new.vue";
import HsAllLoadText from "@/base/hs-null/hs-all-load-text.vue";
import HsButton from "@/base/hs-button/hs-button.vue";
import CostCentersItem from "@/pages/personal/passengers/passenger-details/cost-centers-item.vue";
export default {
  components: {
    CostCentersItem,
    HsButton,
    HsAllLoadText,
    HsSearchBarNew,
    HsNull,
    CHeader: () => import('components/c-header/c-header'),
    HsCell1: () => import('base/hs-tableview/hs-cell-1/hs-cell-1'),
    HsTextarea: () => import('base/hs-textarea/hs-textarea'),
    HsGradientButton: () => import('base/hs-button/hs-gradient-button'),
    HsSection: () => import('base/hs-tableview/hs-section/hs-section'),
    HsScroll: () => import('base/hs-scroll/hs-scroll'),
    HsSearchBar: () => import('base/hs-search-bar/hs-search-bar.vue')
  },
  props: {
    ExtendFieldSettings: {
      type: Object,
      default: () => {
        return {}
      }
    },
    value: {
      type: String,
      default: ''
    },
    ExtendFieldSettingsKey: {
      type: String,
      default: ''
    },
    OrderBusinessType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      show: false,

      tableViewOptions: {
        pullDownRefresh: {
          threshold: 50
        },
        pullUpLoad: false
      },
      PageIndex: 1,
      PageSize: 20,
      KeyWord: '',

      FieldSettings: null,
      datalist: [],
      selIndex: null,
      suggestion: ''
    }
  },
  computed: {
    ExtendFieldName() {
      let ExtendFieldName = this.FieldSettings ? this.FieldSettings.ExtendFieldName : ''
      return ExtendFieldName
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.FieldSettings = {
          ...this.ExtendFieldSettings
        }
        this.KeyWord = ''
        this.suggestion = ''
        this.selIndex = null
        this.datalist = []
        // 0输入 1下拉选择 2输入或下拉选择
        if (this.FieldSettings && Number(this.FieldSettings.ExtendFieldType) === 1) { // 分页
          this.suggestion = this.value
          this.tableViewOptions.pullDownRefresh = {
            threshold: 50
          }
          this._getDatalist()
        } else if (this.FieldSettings && Number(this.FieldSettings.ExtendFieldType) === 2) { // 不分页
          this.tableViewOptions.pullDownRefresh = false
          this.tableViewOptions.pullUpLoad = false
          this._getDatalist()
        } else {
          this.datalist = []
        }
      }
    },
    KeyWord(val) {
      this.timer && clearTimeout(this.timer); // eslint-disable-line
      this.timer = setTimeout(() => {
        this._getDatalist()
      }, 500)
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },

    _getParams() {
      // 0员工  国内机票1  酒店2 旅游3 保险5 国际机票6 火车票10 国际酒店11
      // 国内机票退票12 国内改期机票13 用车14 用餐15 国际机票退票 16 出差申请单 17  汽车票 18
      let BusinessTypeObj = {
        1: 1,
        13: 9,
        12: 10,

        6: 2,
        16: 12,
        206: 11,

        2: 3,
        11: 4,
        10: 5,
        14: 6,
        15: 7,
        17: 13,
        18: 8
      }
      let ExtendTypeObj = {
        ExtendField1: 1,
        ExtendField2: 2,
        ExtendField3: 3,
        ExtendField4: 4,
        ExtendField5: 5
      }
      return {
        BusinessType: BusinessTypeObj[this.OrderBusinessType] || '',
        ExtendType: ExtendTypeObj[this.ExtendFieldSettingsKey],
        KeyWord: this.KeyWord,
        PageSize: this.PageSize
      }
    },

    // 获取订单扩展字段 可选项
    _getDatalist() {
      let params = this._getParams()
      this.PageIndex = 1
      params = {
        ...params,
        PageIndex: 1
      }
      if (this.FieldSettings && Number(this.FieldSettings.ExtendFieldType) === 1) { // 不分页
        console.log('不分页')
        params.IsNeedPage = true
      } else if (this.FieldSettings && Number(this.FieldSettings.ExtendFieldType) === 2) {
        params.IsNeedPage = false
      }
      let ajaxFun = kpiUserGetOrderExtendFields
      if (Number(this.OrderBusinessType) === 0) { // 员工扩展字段
        ajaxFun = kpiUserGetEmployeeExtendFields
      }
      ajaxFun(params).then(res => {
        let ExtendFields = res.ResultData.ExtendFields || []
        this.datalist = ExtendFields
        if (!this.KeyWord) {
          this.datalist.unshift({
            Name: this.$t('DoNotChooseForNow'),
            ID: null,
          })
        }
        if (this.FieldSettings && Number(this.FieldSettings.ExtendFieldType) === 2) { // 不分页
          this._setSelIndex()
        } else {
          if (ExtendFields.length >= this.PageSize) {
            this.tableViewOptions.pullUpLoad = {threshold: 50}
          } else {
            this.tableViewOptions.pullUpLoad = false
          }
        }
        this.$refs.tableView && this.$refs.tableView.forceUpdate();
      })
    },

    // 选中项回显
    _setSelIndex() {
      let index = this.datalist.findIndex(m => m.Name === this.value)
      if ((index || index === 0) && this.value) {
        this.selIndex = index >= 0 ? index : 'other'
        this.suggestion = this.selIndex === 'other' && (this.FieldSettings && Number(this.FieldSettings.ExtendFieldType) === 2) ? this.value : ''
      } else {
        this.selIndex = null
        this.suggestion = ''
      }
      if (this.FieldSettings && Number(this.FieldSettings.ExtendFieldType) === 1) {
        this.selIndex = null
        this.suggestion = ''
      }
    },

    // 获取订单扩展字段 可选项
    _getDatalistMore() {
      let params = this._getParams()
      params = {
        ...params,
        IsNeedPage: true,
        PageIndex: this.PageIndex + 1
      }
      let ajaxFun = kpiUserGetOrderExtendFields
      if (Number(this.OrderBusinessType) === 0) { // 员工扩展字段
        ajaxFun = kpiUserGetEmployeeExtendFields
      }
      ajaxFun(params).then(res => {
        let ExtendFields = res.ResultData.ExtendFields || []
        this.PageIndex++
        this.datalist = this.datalist.concat(ExtendFields)
        if (ExtendFields.length < this.PageSize) {
          this.tableViewOptions.pullUpLoad = false
        } else {
          this.tableViewOptions.pullUpLoad = {threshold: 50}
        }
        this.$refs.tableView && this.$refs.tableView.forceUpdate();
      })
    },

    /** 选择点击事件 */
    _selectedFun(index) {
      console.log(index)
      this.selIndex = index
      if (this.FieldSettings && Number(this.FieldSettings.ExtendFieldType) === 1) {
        let item = this.datalist[index]
        this.$emit('delegate', item.ID === null ? '' : item.Name)
        this.close()
      }
    },
    /** 确定 */
    _submit() {
      console.log('确定')
      let {selIndex, datalist, suggestion} = this
      if (selIndex === null) {
        this.$toast(`${this.$t('PleaseChoose')}/${this.ExtendFieldName}`)
        return
      } else if (selIndex === 'other' && !suggestion) {
        // this.$toast(`${this.$t('PleaseFill_x', 'function', [this.ExtendFieldName])}`)
        this.$toast(`${this.$t('PleaseFill_x', 'function', [this.ExtendFieldName])}`)
        return
      }
      let Purpose = selIndex === 'other' ? suggestion : (datalist[selIndex].ID === null ? '' : datalist[selIndex].Name)
      this.$emit('delegate', Purpose)
      this.close()
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
$imgW = calc(25vw - 18.75px)
.hs-container.c-purpose-travel {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 200;
  background-color: $color_black_20;
  &.whiteBg{
    background-color: $color_black_0;
  }

  .table-view {
    width: 100%;
    height: calc(100% - 45px - 91px);
    overflow: hidden;

    .tab-list {
      padding: 1px 0;
      margin-bottom: 15px;

      .cell {
        width: 100%;
        min-height: 56px;
        padding: 18px 16px;
        position: relative;

        &:last-child {
          &:after {
            display: none;
          }
        }

        &:after {
          position: absolute;
          bottom: 0;
          left: 16px;
          width: calc(100% - 16px);
          content: ' ';
          border-bottom: 0.5px solid $color_black_30;
        }

        > .info {
          @extend .flex-start;
          @extend .hs-font-body;
          align-items: flex-start;
          width: 100%;

          > img {
            width: 16px;
            height: 16px;
            margin-right 8px;
          }
        }
      }
    }

    .hs-textarea {
      @extend .flex-start;
      @extend .hs-font-body;
      width: calc(100% - 24px);
      margin-left: 24px;
      margin-top: 8px;
      background-color: $color_black_20;
      border-radius: 4px;
      margin-bottom: 22px;

      :deep(textarea) {
        padding: 12px;
        border: none;

        &::placeholder {
          @extend .hs-font-body;
          color: $color_black_80;
        }
      }

      :deep(.count-box) {
        @extend .hs-font-caption-1;
        bottom: -22px;
        color: $color_black_50;
        right: 0;
      }
    }
  }

  > footer {
    @extends .flex-between;
    width: 100%;
    padding: 13px 16px;
    background: $color_white;

    .hs-button {
      background: $color_theme_300;
      border-radius: 8px;
      font-weight: 500;
    }
  }
}
</style>
